import './App.css';
import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Authentication from './pages/Authentication';
import Error from "./pages/Error";
import Auth from "./classes/Auth.js";
import User from "./classes/User.js";
import SiteSelection from './pages/SiteSelection.js';
import BuckInventory from './pages/BuckInventory.js';
import ImageUpload from './pages/ImageUpload.js';
import LabelImages from './pages/LabelImages.js';
import SingleBuck from './pages/SingleBuck.js';
import CommPreferences from './pages/CommPreferences.js';
import AccountSettings from './pages/AccountSettings.js';
import { getObjectValue } from './utils/utils.js';
import UserPrivileges from './pages/UserPrivileges.js';
import BuckReportPDF from './pages/BuckReportPDF.js';
import SiteStats from './pages/SiteStats.js';

const auth = new Auth();

function App() {
    const [currentProfile, setCurrentProfile] = useState(null);
    const [authenticated, setAuthenticated] = useState(auth.isAuthenticated());
    const [sitesFetched, setSitesFetched] = useState(false);

    const navigate = useNavigate();
    let location = useLocation();
  
    useEffect(() => {
        document.title = 'Vale-Outdoors';
    });

    // Start of Hook for mobile styling
    const isMobileThreshold = 768; // value in px
    const [isMobile, setIsMobile] = useState(window.innerWidth <= isMobileThreshold);
  
    function handleWindowSizeChange() {
        setIsMobile(window.innerWidth <= isMobileThreshold);
    };

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);
    // End of Hook for mobile styling

    useEffect(() => {
        if(authenticated && auth.getProfile()) {
            let profile = auth.getProfile();
            Object.assign(profile, { "accessToken": auth.accessToken });
            // console.log(profile);

            createProfile(profile);
        } else {
            auth.renewTokens().then((response) => {
                if(response) {
                    setAuthenticated(auth.isAuthenticated());
                } else {
                    navigate("/login");
                }
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authenticated]);

    const createProfile = async (profile) => {
        let newCurrentProfile = new User(profile);
        await newCurrentProfile.getSites();
        // console.log(newCurrentProfile);

        setSitesFetched(true);

        setCurrentProfile(newCurrentProfile);
    };

    const updateProfile = async (updatedProfile) => {
        let newlyUpdatedProfile = await currentProfile.updateProfile(updatedProfile);
        if(newlyUpdatedProfile) {
            if(getObjectValue(updatedProfile, "accessToken")) {
                Object.assign(newlyUpdatedProfile, { "accessToken": updatedProfile.accessToken });
            }
            // console.log(newlyUpdatedProfile);
    
            createProfile(newlyUpdatedProfile);
    
            return true;
        } else {
            return false;
        }
    };

    return (
        <>
            {window.location.pathname.includes("buck_report") ? null : (
                <Navbar currentProfile={currentProfile} isMobile={isMobile} />
            )}
            <Routes>
                {['/', '/login/', '/login/:referrer', '/register/', '/callback/', '/logout/'].map((path, index) => <Route key={index} exact path={path} element={<Authentication auth={auth} location={location} />} />)}
                {['/sites/', '/:sub/sites'].map((path, index) => <Route key={index + 5} exact path={path} element={<SiteSelection isMobile={isMobile} currentProfile={currentProfile} setCurrentProfile={setCurrentProfile} sitesFetched={sitesFetched} />} />)}
                {['/sites/:site/inventory', '/:sub/sites/:site/inventory'].map((path, index) => <Route key={index + 7} exact path={path} element={<BuckInventory isMobile={isMobile} currentProfile={currentProfile} setCurrentProfile={setCurrentProfile} />} />)}
                {['/sites/:site/inventory/:buck', '/:sub/sites/:site/inventory/:buck'].map((path, index) => <Route key={index + 9} exact path={path} element={<SingleBuck isMobile={isMobile} currentProfile={currentProfile} />} />)}
                {['/sites/:site/label', '/:sub/sites/:site/label', '/sites/:site/label/:selectedChunk', '/:sub/sites/:site/label/:selectedChunk'].map((path, index) => <Route key={index + 11} exact path={path} element={<LabelImages isMobile={isMobile} currentProfile={currentProfile} setCurrentProfile={setCurrentProfile} />} />)}
                <Route exact path="/account/:sub" element={<AccountSettings currentProfile={currentProfile} isMobile={isMobile} setCurrentProfile={updateProfile} />} />
                <Route exact path="/users/privileges" element={<UserPrivileges currentProfile={currentProfile} isMobile={isMobile} />} />
                <Route exact path="/sites/:site/buck_report" element={<BuckReportPDF currentProfile={currentProfile} isMobile={isMobile} />} />
                <Route exact path="/sites/:site/stats" element={<SiteStats currentProfile={currentProfile} isMobile={isMobile} />} />
                {['/sites/:site/upload', '/:sub/sites/:site/upload'].map((path, index) => <Route key={index + 13} exact path={path} element={<ImageUpload isMobile={isMobile} currentProfile={currentProfile} setCurrentProfile={setCurrentProfile} />} />)}
                {['/unsubscribe/:refEmail', '/unsubscribe'].map((path, index) => <Route key={index + 85} exact path={path} element={<CommPreferences isMobile={isMobile} />} />)}
                <Route path="*" element={<Error isMobile={isMobile} />} />
            </Routes>
            {window.location.pathname.includes("buck_report") ? null : (
                <Footer />
            )}
        </>
    );
}

export default App;  